// Translation: External > Provider button (English)
export default Object.freeze({
	continueWithProvider: 'Continue with {{provider}}',
	signUpWithProvider: 'Sign up with {{provider}}',
	signInWithProvider: 'Sign in with {{provider}}'
})
